import { connect } from 'react-redux';
import { appModalOpen } from 'actions';
import View from './';

const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => {
  return {
    appModalOpen(payload) {
      dispatch(appModalOpen(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(View);



// WEBPACK FOOTER //
// ./js/components/advisory-header/container.js